<div class="scanner-page">
  <div class="top-bar">
    <button type="button" class="btn btn-secondary back-btn" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      {{ 'COMMON.BACK' | translate }}
    </button>
    <p class="scan-hint">{{ 'PICKUP.SCAN_HINT' | translate }}</p>
  </div>

  <div class="ready-actions">
    <button
      type="button"
      class="btn btn-primary buses-ready-btn"
      (click)="openAllBusesReadyConfirm()"
      [disabled]="markingBusesReady"
    >
      <mat-icon>directions_bus</mat-icon>
      {{ (markingBusesReady ? 'PICKUP.ALL_BUSES_READY_WORKING' : 'PICKUP.ALL_BUSES_READY') | translate }}
    </button>
  </div>

  <div class="modal-backdrop" *ngIf="showAllBusesReadyConfirm" (click)="onAllBusesReadyConfirm(false)">
    <div class="modal-panel" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'PICKUP.ALL_BUSES_READY_CONFIRM_TITLE' | translate }}</h3>
      </div>
      <div class="modal-body">
        <p>{{ 'PICKUP.ALL_BUSES_READY_CONFIRM_BODY' | translate }}</p>
      </div>
      <div class="modal-footer buses-ready-confirm-footer">
        <button
          type="button"
          class="btn buses-ready-cancel-btn"
          (click)="onAllBusesReadyConfirm(false)"
        >
          {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button
          type="button"
          class="btn buses-ready-confirm-btn"
          (click)="onAllBusesReadyConfirm(true)"
          [disabled]="markingBusesReady"
        >
          {{ 'PICKUP.ALL_BUSES_READY' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="scanner-stage-wrap">
    <div #scannerStage class="scanner-stage" [class.is-scanning]="cameraActive">
      <div [id]="scannerElementId" class="scanner-host" [class.hidden-host]="!cameraActive"></div>

      <div
        class="viewfinder"
        *ngIf="cameraActive"
        [ngStyle]="viewfinderStyle"
        aria-hidden="true"
      >
        <span class="corner corner-tl"></span>
        <span class="corner corner-tr"></span>
        <span class="corner corner-bl"></span>
        <span class="corner corner-br"></span>
        <span class="scan-line"></span>
      </div>

      <div class="scanner-overlay" *ngIf="!cameraActive">
        <p class="scanner-error" *ngIf="cameraError">{{ cameraError | translate }}</p>
        <button
          type="button"
          class="btn btn-primary start-camera-btn"
          (click)="onStartCameraClick()"
          [disabled]="!!cameraError && cameraError === 'ATTENDANCE.HTTPS_REQUIRED'"
        >
          <mat-icon>photo_camera</mat-icon>
          {{ 'ATTENDANCE.START_CAMERA' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div
    class="scan-feedback"
    *ngIf="feedback; else feedbackPlaceholder"
    [attr.data-kind]="feedback.kind"
  >
    <div class="feedback-main">
      <strong class="feedback-title">{{ feedback.titleKey | translate }}</strong>
      <span class="feedback-name" *ngIf="feedback.detailName">{{ feedback.detailName }}</span>
      <span class="feedback-meta" *ngIf="feedback.className">{{ feedback.className }}</span>
      <span class="feedback-meta" *ngIf="feedback.message">{{ feedback.message }}</span>
    </div>
  </div>
</div>

<ng-template #feedbackPlaceholder>
  <div class="scan-feedback placeholder" aria-hidden="true"></div>
</ng-template>
